// import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { TotalsType } from 'Type/MiniCart.type';
import { formatPrice } from 'Util/Price';

import './CartFreeShipping.style';

/** @namespace PeggysagePwa/Component/CartFreeShipping/Component */
export class CartFreeShippingComponent extends PureComponent {
    static propTypes = {
        totals: TotalsType.isRequired
    };

    render() {
        const {
            totals: {
                items,
                freeshipping_remaining_amount: remainingAmount,
                prices: {
                    quote_currency_code: currencyCode
                } = {}
            } = {}
        } = this.props;

        if (!items || items.length < 1) {
            return null;
        }

        const remainingAmountFormatted = formatPrice(remainingAmount, currencyCode);

        const message = remainingAmount
            ? __('Only %s left to benefit from free shipping', remainingAmountFormatted)
            : __('Free shipping');

        return (
            <div block="CartFreeShipping">
                { message }
            </div>
        );
    }
}

export default CartFreeShippingComponent;
